import { WIDGET_LOGICAL_NAMES } from '@config/Consts';

// Assumptions: We always add new metrics and new widgets at the end of the existing array,
// and we never delete from the configuration, only mark as deleted true
const defaultAccountSettings = [
  {
    AMW_version_from: '1.9.1',
    AMW_version_to: '1.9.2',
    force_update_params: [
      'configuration[2].metrics[0].config.deleted',
      'configuration[2].metrics[0].config.configurable',
      'configuration[2].metrics[3].config.configurable',
      'configuration[3].metrics[2].config.configurable',
      'configuration[3].metrics[3].config.displayOrder',
      'configuration[3].metrics[4].config.displayOrder',
      'configuration[3].metrics[5].config.displayOrder',
      'configuration[3].metrics[6].config.displayOrder',
      'configuration[3].metrics[7].config.displayOrder',
      'configuration[3].metrics[8].config.displayOrder',
      'configuration[3].metrics[9].config.displayOrder',
      'configuration[3].metrics[10]',
    ],
    configuration: [
      {
        widget_name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
        metrics: [],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
        metrics: [
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'overdue',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              parentMetric: 'assigned',
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'first_response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'first_response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'first_response_time',
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'response_time',
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.AGENTS,
        metrics: [
          {
            name: 'state',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'state_duration',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'online_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'skills',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'active',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'max_open',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
              reducedDisplayOrder: 6,
            },
          },
          {
            name: 'agent_picture',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
        metrics: [
          {
            name: 'status',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'visitor_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'skill',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
            },
          },
          {
            name: 'start_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
            },
          },
          {
            name: 'mcs',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
            },
          },
          {
            name: 'nps',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
            },
          },
          {
            name: 'brand_name',
            config: {
              enabled: false, // Code will change to true for ContactCenter account (Rollover) only
              configurable: false,
              deleted: false,
              displayOrder: 4,
              ACFeatureEnabled: false,
            },
          },
        ],
      },
    ],
  },
  {
    AMW_version_from: '1.9.3',
    AMW_version_to: '1.9.99',
    force_update_params: [],
    configuration: [
      {
        widget_name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
        metrics: [
          {
            name: 'total_unassigned',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'overdue',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              parentMetric: 'total_unassigned',
            },
          },
          {
            name: 'skill_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'unassigned_conversations',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'skill_wait_time',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 4,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
        metrics: [
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'overdue',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              parentMetric: 'assigned',
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'first_response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'first_response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'first_response_time',
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'response_time',
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.AGENTS,
        metrics: [
          {
            name: 'state',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'state_duration',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'online_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'skills',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'active',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'max_open',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
              reducedDisplayOrder: 6,
            },
          },
          {
            name: 'agent_picture',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
        metrics: [
          {
            name: 'status',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'visitor_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'skill',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
            },
          },
          {
            name: 'start_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
            },
          },
          {
            name: 'mcs',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
            },
          },
          {
            name: 'nps',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
            },
          },
          {
            name: 'brand_name',
            config: {
              enabled: false, // Code will change to true for ContactCenter account (Rollover) only
              configurable: false,
              deleted: false,
              displayOrder: 4,
              ACFeatureEnabled: false,
            },
          },
        ],
      },
    ],
  },
  {
    AMW_version_from: '1.10.0',
    AMW_version_to: '1.10.99',
    force_update_params: [
      'configuration[3].metrics[6].config.displayOrder',
      'configuration[3].metrics[7].config.displayOrder',
      'configuration[3].metrics[8].config.displayOrder',
      'configuration[3].metrics[9].config.displayOrder',
      'configuration[3].metrics[10].config.ACFeatureEnabled',
      'configuration[3].metrics[11].config',
    ],
    configuration: [
      {
        widget_name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
        metrics: [
          {
            name: 'total_unassigned',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'overdue',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              parentMetric: 'total_unassigned',
            },
          },
          {
            name: 'skill_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'unassigned_conversations',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'skill_wait_time',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 4,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
        metrics: [
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'overdue',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              parentMetric: 'assigned',
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'first_response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'first_response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'first_response_time',
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'response_time',
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.AGENTS,
        metrics: [
          {
            name: 'state',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'state_duration',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'online_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'skills',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'active',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'max_open',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
              reducedDisplayOrder: 6,
            },
          },
          {
            name: 'agent_picture',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
        metrics: [
          {
            name: 'status',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'visitor_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'skill',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
            },
          },
          {
            name: 'start_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
            },
          },
          {
            name: 'mcs',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
            },
          },
          {
            name: 'nps',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
            },
          },
          {
            name: 'brand_name',
            config: {
              enabled: false, // Code will change to true for ContactCenter account (Rollover) only
              configurable: false,
              deleted: false,
              displayOrder: 4,
              ACFeatureEnabled: false,
            },
          },
          {
            name: 'intents',
            config: {
              enabled: false, // Code will change to true for LiveIntent accounts only
              configurable: false,
              deleted: false,
              displayOrder: 8,
              ACFeatureEnabled: false,
            },
          },
        ],
      },
    ],
  },
  {
    AMW_version_from: '1.11.0',
    AMW_version_to: '1.11.99',
    force_update_params: [
      'configuration[2].metrics[0].config.enabled',
      'configuration[2].metrics[0].config.configurable',
      'configuration[2].metrics[3].config.enabled',
      'configuration[2].metrics[3].config.configurable',
    ],
    configuration: [
      {
        widget_name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
        metrics: [
          {
            name: 'total_unassigned',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'overdue',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              parentMetric: 'total_unassigned',
            },
          },
          {
            name: 'skill_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'unassigned_conversations',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'skill_wait_time',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 4,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
        metrics: [
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'overdue',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              parentMetric: 'assigned',
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'first_response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'first_response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'first_response_time',
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'response_time',
            },
          },
          {
            name: 'human_online_load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'load',
            },
          },
          {
            name: 'human_away_load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'load',
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.AGENTS,
        metrics: [
          {
            name: 'state',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'state_duration',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'online_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'skills',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'active',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'max_open',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
              reducedDisplayOrder: 6,
            },
          },
          {
            name: 'agent_picture',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
        metrics: [
          {
            name: 'status',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'visitor_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'skill',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
            },
          },
          {
            name: 'start_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
            },
          },
          {
            name: 'mcs',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
            },
          },
          {
            name: 'nps',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
            },
          },
          {
            name: 'brand_name',
            config: {
              enabled: false, // Code will change to true for ContactCenter account (Rollover) only
              configurable: false,
              deleted: false,
              displayOrder: 4,
              ACFeatureEnabled: false,
            },
          },
          {
            name: 'intents',
            config: {
              enabled: false, // Code will change to true for LiveIntent accounts only
              configurable: false,
              deleted: false,
              displayOrder: 8,
              ACFeatureEnabled: false,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.SKILLS,
        metrics: [
          {
            name: 'skill_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'open_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'overdue_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'unassigned_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'actionable_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'overdue_unassigned_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'wait_time_agent_assignment_50_percentile',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 7,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'wait_time_agent_assignment_90_percentile',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'assigned_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
              reducedDisplayOrder: 6,
            },
          },
          {
            name: 'overdue_assigned_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 10,
            },
          },
          {
            name: 'skill_load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 7,
            },
          },
          {
            name: 'skill_online_agents',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
              reducedDisplayOrder: 8,
            },
          },
          {
            name: 'skill_away_agents',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 13,
              reducedDisplayOrder: 9,
            },
          },
          {
            name: 'skill_back_soon_agents',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 14,
              reducedDisplayOrder: 10,
            },
          },
          {
            name: 'closed_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 15,
              reducedDisplayOrder: 11,
            },
          },
          {
            name: 'average_wait_time_first_response',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 16,
              reducedDisplayOrder: 12,
            },
          },
          {
            name: 'average_time_to_first_response_first_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 17,
              reducedDisplayOrder: 13,
            },
          },
          {
            name: 'average_wait_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 18,
              reducedDisplayOrder: 14,
            },
          },
          {
            name: 'average_time_to_response',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 19,
              reducedDisplayOrder: 15,
            },
          },
        ],
      },
    ],
  },
  {
    AMW_version_from: '1.12.0',
    AMW_version_to: '1.13.99',
    force_update_params: [
      'configuration[2].metrics[3].config.configurable',
    ],
    configuration: [
      {
        widget_name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
        metrics: [
          {
            name: 'total_unassigned',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'overdue',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              parentMetric: 'total_unassigned',
            },
          },
          {
            name: 'skill_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'unassigned_conversations',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'skill_wait_time',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 4,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
        metrics: [
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'overdue',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              parentMetric: 'assigned',
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'first_response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'first_response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'first_response_time',
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'response_time',
            },
          },
          {
            name: 'human_online_load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'load',
            },
          },
          {
            name: 'human_away_load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'load',
            },
          },
          {
            name: 'closed_by_agent',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'closed',
            },
          },
          {
            name: 'closed_by_consumer',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'closed',
            },
          },
          {
            name: 'auto_closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'closed',
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.AGENTS,
        metrics: [
          {
            name: 'state',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'state_duration',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'online_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'skills',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'active',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'max_open',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
              reducedDisplayOrder: 6,
            },
          },
          {
            name: 'agent_picture',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
        metrics: [
          {
            name: 'status',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'visitor_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'skill',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
            },
          },
          {
            name: 'start_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
            },
          },
          {
            name: 'mcs',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
            },
          },
          {
            name: 'nps',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
            },
          },
          {
            name: 'brand_name',
            config: {
              enabled: false, // Code will change to true for ContactCenter account (Rollover) only
              configurable: false,
              deleted: false,
              displayOrder: 4,
              ACFeatureEnabled: false,
            },
          },
          {
            name: 'intents',
            config: {
              enabled: false, // Code will change to true for LiveIntent accounts only
              configurable: false,
              deleted: false,
              displayOrder: 8,
              ACFeatureEnabled: false,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.SKILLS,
        metrics: [
          {
            name: 'skill_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'open_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'overdue_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'unassigned_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'actionable_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'overdue_unassigned_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'wait_time_agent_assignment_50_percentile',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 7,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'wait_time_agent_assignment_90_percentile',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'assigned_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
              reducedDisplayOrder: 6,
            },
          },
          {
            name: 'overdue_assigned_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 10,
            },
          },
          {
            name: 'skill_load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 7,
            },
          },
          {
            name: 'skill_online_agents',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
              reducedDisplayOrder: 8,
            },
          },
          {
            name: 'skill_away_agents',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 13,
              reducedDisplayOrder: 9,
            },
          },
          {
            name: 'skill_back_soon_agents',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 14,
              reducedDisplayOrder: 10,
            },
          },
          {
            name: 'closed_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 15,
              reducedDisplayOrder: 11,
            },
          },
          {
            name: 'average_wait_time_first_response',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 16,
              reducedDisplayOrder: 12,
            },
          },
          {
            name: 'average_time_to_first_response_first_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 17,
              reducedDisplayOrder: 13,
            },
          },
          {
            name: 'average_wait_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 18,
              reducedDisplayOrder: 14,
            },
          },
          {
            name: 'average_time_to_response',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 19,
              reducedDisplayOrder: 15,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.BOTS,
        metrics: [
          {
            name: 'bot_picture',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
            },
          },
          {
            name: 'bot_status',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'bot_name',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'bot_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'bot_skills',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'assigned_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'pending_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'concluded_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'transfer_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'closed_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'bot_intents',
            config: {
              enabled: false,
              configurable: false,
              deleted: false,
              displayOrder: 10,
              reducedDisplayOrder: 6,
            },
          },
          {
            name: 'bot_csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 7,
            },
          },
        ],
      },
    ],
  },
  {
    AMW_version_from: '2.0.0',
    AMW_version_to: '2.1.99',
    force_update_params: [
      'configuration[2].metrics[0].config.displayOrder',
      'configuration[2].metrics[1].config.displayOrder',
      'configuration[2].metrics[2].config.displayOrder',
      'configuration[2].metrics[3].config.displayOrder',
      'configuration[2].metrics[4].config.displayOrder',
      'configuration[2].metrics[5].config.displayOrder',
      'configuration[2].metrics[6].config.displayOrder',
      'configuration[2].metrics[7].config.displayOrder',
      'configuration[2].metrics[8].config.displayOrder',
      'configuration[2].metrics[9].config.displayOrder',
      'configuration[2].metrics[10].config.displayOrder',
      'configuration[2].metrics[11].config.displayOrder',
      'configuration[2].metrics[12].config.displayOrder',
      'configuration[2].metrics[13].config.displayOrder',
    ],
    configuration: [
      {
        widget_name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
        metrics: [
          {
            name: 'total_unassigned',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'overdue',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              parentMetric: 'total_unassigned',
            },
          },
          {
            name: 'skill_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'unassigned_conversations',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'skill_wait_time',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 4,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
        metrics: [
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'overdue',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              parentMetric: 'assigned',
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'first_response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'first_response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'first_response_time',
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'response_time',
            },
          },
          {
            name: 'human_online_load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'load',
            },
          },
          {
            name: 'human_away_load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'load',
            },
          },
          {
            name: 'closed_by_agent',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'closed',
            },
          },
          {
            name: 'closed_by_consumer',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'closed',
            },
          },
          {
            name: 'auto_closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'closed',
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.AGENTS,
        metrics: [
          {
            name: 'state',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'state_duration',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'online_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'skills',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
            },
          },
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'active',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'max_open',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 13,
              reducedDisplayOrder: 6,
            },
          },
          {
            name: 'agent_picture',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
            },
          },
          {
            name: 'notifications',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
        metrics: [
          {
            name: 'status',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'visitor_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'skill',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
            },
          },
          {
            name: 'start_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
            },
          },
          {
            name: 'mcs',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
            },
          },
          {
            name: 'nps',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
            },
          },
          {
            name: 'brand_name',
            config: {
              enabled: false, // Code will change to true for ContactCenter account (Rollover) only
              configurable: false,
              deleted: false,
              displayOrder: 4,
              ACFeatureEnabled: false,
            },
          },
          {
            name: 'intents',
            config: {
              enabled: false, // Code will change to true for LiveIntent accounts only
              configurable: false,
              deleted: false,
              displayOrder: 8,
              ACFeatureEnabled: false,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.SKILLS,
        metrics: [
          {
            name: 'skill_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'open_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'overdue_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'unassigned_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'actionable_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'overdue_unassigned_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'wait_time_agent_assignment_50_percentile',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 7,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'wait_time_agent_assignment_90_percentile',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'assigned_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
              reducedDisplayOrder: 6,
            },
          },
          {
            name: 'overdue_assigned_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 10,
            },
          },
          {
            name: 'skill_load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 7,
            },
          },
          {
            name: 'skill_online_agents',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
              reducedDisplayOrder: 8,
            },
          },
          {
            name: 'skill_away_agents',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 13,
              reducedDisplayOrder: 9,
            },
          },
          {
            name: 'skill_back_soon_agents',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 14,
              reducedDisplayOrder: 10,
            },
          },
          {
            name: 'closed_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 15,
              reducedDisplayOrder: 11,
            },
          },
          {
            name: 'average_wait_time_first_response',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 16,
              reducedDisplayOrder: 12,
            },
          },
          {
            name: 'average_time_to_first_response_first_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 17,
              reducedDisplayOrder: 13,
            },
          },
          {
            name: 'average_wait_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 18,
              reducedDisplayOrder: 14,
            },
          },
          {
            name: 'average_time_to_response',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 19,
              reducedDisplayOrder: 15,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.BOTS,
        metrics: [
          {
            name: 'bot_picture',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
            },
          },
          {
            name: 'bot_status',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'bot_name',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'bot_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'bot_skills',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'assigned_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'pending_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'concluded_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'transfer_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'closed_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'bot_intents',
            config: {
              enabled: false,
              configurable: false,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 6,
            },
          },
          {
            name: 'bot_csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
              reducedDisplayOrder: 7,
            },
          },
          {
            name: 'notifications',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
        ],
      },
    ],
  },
  {
    AMW_version_from: '2.2.0',
    force_update_params: [
      'configuration[2].metrics[0].config.displayOrder',
      'configuration[2].metrics[1].config.displayOrder',
      'configuration[2].metrics[2].config.displayOrder',
      'configuration[2].metrics[3].config.displayOrder',
      'configuration[2].metrics[4].config.displayOrder',
      'configuration[2].metrics[5].config.displayOrder',
      'configuration[2].metrics[6].config.displayOrder',
      'configuration[2].metrics[7].config.displayOrder',
      'configuration[2].metrics[8].config.displayOrder',
      'configuration[2].metrics[9].config.displayOrder',
      'configuration[2].metrics[10].config.displayOrder',
      'configuration[2].metrics[11].config',
      'configuration[2].metrics[12].config.displayOrder',
      'configuration[2].metrics[13].config.displayOrder',
    ],
    configuration: [
      {
        widget_name: WIDGET_LOGICAL_NAMES.IN_QUEUE,
        metrics: [
          {
            name: 'total_unassigned',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'overdue',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              parentMetric: 'total_unassigned',
            },
          },
          {
            name: 'skill_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'unassigned_conversations',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'skill_wait_time',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 4,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.SHIFT_STATUS,
        metrics: [
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'overdue',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              parentMetric: 'assigned',
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'first_response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'first_response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'first_response_time',
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'response_time_from_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'response_time',
            },
          },
          {
            name: 'human_online_load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'load',
            },
          },
          {
            name: 'human_away_load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'load',
            },
          },
          {
            name: 'closed_by_agent',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'closed',
            },
          },
          {
            name: 'closed_by_consumer',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'closed',
            },
          },
          {
            name: 'auto_closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              parentMetric: 'closed',
            },
          },
          {
            name: 'avg_conversations_duration',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.AGENTS,
        metrics: [
          {
            name: 'state',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'state_duration',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'online_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'skills',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
            },
          },
          {
            name: 'assigned',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'active',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'max_open',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
            },
          },
          {
            name: 'load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'closed',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 14,
              reducedDisplayOrder: 7,
            },
          },
          {
            name: 'agent_picture',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
            },
          },
          {
            name: 'notifications',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'transfer_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 13,
              reducedDisplayOrder: 6,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.CONVERSATIONS,
        metrics: [
          {
            name: 'status',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 1,
            },
          },
          {
            name: 'response_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'visitor_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'agent_name',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'agent_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'skill',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
            },
          },
          {
            name: 'start_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
            },
          },
          {
            name: 'mcs',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
            },
          },
          {
            name: 'csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
            },
          },
          {
            name: 'nps',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
            },
          },
          {
            name: 'brand_name',
            config: {
              enabled: false, // Code will change to true for ContactCenter account (Rollover) only
              configurable: false,
              deleted: false,
              displayOrder: 4,
              ACFeatureEnabled: false,
            },
          },
          {
            name: 'intents',
            config: {
              enabled: false, // Code will change to true for LiveIntent accounts only
              configurable: false,
              deleted: false,
              displayOrder: 8,
              ACFeatureEnabled: false,
            },
          },
          {
            name: 'close_reason',
            config: {
              enabled: true, // Code will change to true for LiveIntent accounts only
              configurable: true,
              deleted: false,
              displayOrder: 13,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.SKILLS,
        metrics: [
          {
            name: 'skill_name',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'open_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 2,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'overdue_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'unassigned_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'actionable_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'overdue_unassigned_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 6,
            },
          },
          {
            name: 'wait_time_agent_assignment_50_percentile',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 7,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'wait_time_agent_assignment_90_percentile',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'assigned_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
              reducedDisplayOrder: 6,
            },
          },
          {
            name: 'overdue_assigned_conversations',
            config: {
              enabled: false,
              configurable: true,
              deleted: false,
              displayOrder: 10,
            },
          },
          {
            name: 'skill_load',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 7,
            },
          },
          {
            name: 'skill_online_agents',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
              reducedDisplayOrder: 8,
            },
          },
          {
            name: 'skill_away_agents',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 13,
              reducedDisplayOrder: 9,
            },
          },
          {
            name: 'skill_back_soon_agents',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 14,
              reducedDisplayOrder: 10,
            },
          },
          {
            name: 'closed_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 15,
              reducedDisplayOrder: 11,
            },
          },
          {
            name: 'average_wait_time_first_response',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 16,
              reducedDisplayOrder: 12,
            },
          },
          {
            name: 'average_time_to_first_response_first_assignment',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 17,
              reducedDisplayOrder: 13,
            },
          },
          {
            name: 'average_wait_time',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 18,
              reducedDisplayOrder: 14,
            },
          },
          {
            name: 'average_time_to_response',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 19,
              reducedDisplayOrder: 15,
            },
          },
        ],
      },
      {
        widget_name: WIDGET_LOGICAL_NAMES.BOTS,
        metrics: [
          {
            name: 'bot_picture',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
            },
          },
          {
            name: 'bot_status',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 2,
            },
          },
          {
            name: 'bot_name',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 3,
            },
          },
          {
            name: 'bot_group',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 4,
            },
          },
          {
            name: 'bot_skills',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 5,
            },
          },
          {
            name: 'assigned_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 6,
              reducedDisplayOrder: 1,
            },
          },
          {
            name: 'pending_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 7,
              reducedDisplayOrder: 2,
            },
          },
          {
            name: 'concluded_conversations',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 8,
              reducedDisplayOrder: 3,
            },
          },
          {
            name: 'transfer_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 9,
              reducedDisplayOrder: 4,
            },
          },
          {
            name: 'closed_rate',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 10,
              reducedDisplayOrder: 5,
            },
          },
          {
            name: 'bot_intents',
            config: {
              enabled: false,
              configurable: false,
              deleted: false,
              displayOrder: 11,
              reducedDisplayOrder: 6,
            },
          },
          {
            name: 'bot_csat',
            config: {
              enabled: true,
              configurable: true,
              deleted: false,
              displayOrder: 12,
              reducedDisplayOrder: 7,
            },
          },
          {
            name: 'notifications',
            config: {
              enabled: true,
              configurable: false,
              deleted: false,
              displayOrder: 1,
            },
          },
        ],
      },
    ],
  },
];
export default defaultAccountSettings;
